class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.buttonTextEl = this.querySelector('[data-sticky-button-text]');
    this.button = this.querySelector('.sticky-add-to-cart__button');

    this.trigger = document.querySelector(`#ProductInfo-${this.sectionId} .product-form__buttons`);

    if (this.trigger && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('sticky-add-to-cart--visible', !entry.isIntersecting);
        });
      });
      this.observer.observe(this.trigger);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event?.data || event.data.sectionId !== this.sectionId) return;

        const updatedPrice = document.getElementById(`price-${this.sectionId}`);
        if (updatedPrice && this.priceEl) {
          this.priceEl.innerHTML = updatedPrice.innerHTML;
        }

        const variant = event.data.variant;
        if (!this.button) return;

        if (!variant) {
          this.button.setAttribute('disabled', 'disabled');
          if (this.buttonTextEl) this.buttonTextEl.textContent = window.variantStrings?.unavailable ?? '';
        } else if (!variant.available) {
          this.button.setAttribute('disabled', 'disabled');
          if (this.buttonTextEl) this.buttonTextEl.textContent = window.variantStrings?.soldOut ?? '';
        } else {
          this.button.removeAttribute('disabled');
          if (this.buttonTextEl) this.buttonTextEl.textContent = window.variantStrings?.addToCart ?? '';
        }
      });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.unsubscribeVariantChange?.();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
